import React from "react"
import { Text } from "react-native"
import { Typography } from "../styles"

export default function Component({ children, style }) {
  return <Text style={[Typography.bodyText, style]}>{children}</Text>
}
